import React, { useState } from "react";
import Lang from "../../../userPreferences/staticWords";
import DropDownList from "../../sharedComponents/dropdown/dropdown";
import RadioButton from "../../sharedComponents/radiobutton/radioButton";
import Button from "../../sharedComponents/buttons/button";
import FilesList from "../../reusableComponents/filesList";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../formikValidation";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";
import Alerts from "../../reusableComponents/alert";
import FileUploader from "../../reusableComponents/fileUploader";
const PageTwo = ({ setPages, setPageTwoData, pageTwoData, dropdownLists }) => {
  const submit = (values) => {
    if (formik.values.education) {
      if (formik.values.attachment) {
        setPageTwoData(values);
        nextRender();
      }
    } else {
      setPageTwoData(values);
      nextRender();
    }
  };
  const [files, setFiles] = useState(
    pageTwoData.attachment === undefined || pageTwoData.attachment == ""
      ? []
      : [...pageTwoData.attachment]
  );
  const [error, setError] = useState(false);
  const [haveCertificate, setHaveCertificate] = useState(false);
  const [duplicateAlert, setDuplicateAlert] = useState(false);
  const [noFilesAlert, setNoFilesAlert] = useState(false);

  const formik = useFormik(
    formikSetup(initialValues, pageTwoData, validationSchema, "pageTwo", submit)
  );
  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
  } = formik;
  const nextRender = () => {
    setPages({ one: false, two: false, three: true });
  };
  const prevRender = () => {
    setPages({ one: true, two: false, three: false });
  };

  return (
    <>
      <div className="col-8">
        <Alerts
          variant={"danger"}
          buttonContent={
            getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
          }
          content={
            getDir(getCurrentLangFromRedux()) == "rtl"
              ? "هذا الملف تم رفعه من قبل"
              : "this file uploaded already"
          }
          title={
            getDir(getCurrentLangFromRedux()) == "rtl"
              ? "ملف متكرر"
              : "duplicate file"
          }
          show={duplicateAlert}
          setShow={setDuplicateAlert}
        />
        <Alerts
          variant={"danger"}
          buttonContent={
            getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
          }
          content={
            getDir(getCurrentLangFromRedux()) == "rtl"
              ? "برجاء رفع بعض الملفات"
              : "please upload some files"
          }
          title={
            getDir(getCurrentLangFromRedux()) == "rtl"
              ? "لا يوجد ملفات"
              : "No Files Here"
          }
          show={noFilesAlert}
          setShow={setNoFilesAlert}
        />
      </div>

      <form onSubmit={handleSubmit} style={{ display: "contents" }}>
        <DropDownList
          dataSource={dropdownLists.professionalStatuses}
          value={values.professionalStatus}
          change={(e) => {
            setFieldValue("professionalStatus", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "professionalStatus")}
          placeholder={Lang.professionalStatus}
          iconName={"paperclip"}
          iconSize={16}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></DropDownList>
        <DropDownList
          multiSelect={true}
          dataSource={dropdownLists.researchAreas}
          value={values.proessionalAreaOfResearch}
          change={(e) => {
            setFieldValue("proessionalAreaOfResearch", e.value);
          }}
          errorMessage={formikValidation(
            touched,
            errors,
            "proessionalAreaOfResearch"
          )}
          placeholder={Lang.proessionalAreaOfResearch}
          iconName={"paperclip"}
          iconSize={16}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></DropDownList>
        <div className="col-md-10 col-12 mt-4 d-flex justify-content-center">
          <DropDownList
            multiSelect={true}
            dataSource={dropdownLists.preferences}
            value={values.preferances}
            change={(e) => {
              setFieldValue("preferances", e.value);
            }}
            errorMessage={formikValidation(touched, errors, "preferances")}
            placeholder={Lang.preferances}
            iconName={"paperclip"}
            iconSize={16}
            containerStyle={"col-md-10 col-12 p-0"}
          ></DropDownList>
        </div>
        {haveCertificate ? (
          <div className="my-2">
            could you upload your certificates or change your answer for
            previous question.{" "}
            <span
              className="text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setFieldValue("education", "");
                setHaveCertificate(false);
              }}
            >
              {" "}
              Change{" "}
            </span>
          </div>
        ) : (
          <div className="col-11 col-md-8">
            <div className="mt-2 mb-1 d-flex">
              <div className=""> dsdsdsn</div>
              <div className="mx-3 text-danger">
                {formikValidation(touched, errors, "education")}
              </div>
            </div>
            <>
              <RadioButton
                change={(e) => {
                  setFieldValue("education", e.value);
                  setHaveCertificate(true);
                }}
                checked={values.education === true}
                value={true}
                name={"education"}
                label={"Yes"}
                containerStyle={"mt-2 mb-1 "}
              ></RadioButton>
              <RadioButton
                checked={values.education === false}
                change={(e) => {
                  setFieldValue("education", e.value);
                  setFieldValue("attachment", "");
                }}
                value={false}
                name={"education"}
                label={"No"}
                containerStyle={"mb-1 mt-1"}
              ></RadioButton>
            </>
          </div>
        )}
        {values.education ? (
          <>
            <FileUploader
              containerStyle={" col-md-10 col-12 justify-content-center"}
              contentStyle={"col-md-10 col-12 mt-3 py-1"}
              borderColor={"#C7C7C9"}
              placeholder={Lang.filesLabel}
              placeholderLTRWidth={150}
              placeholderRTLWidth={115}
              fileTypeValue={values.fileType}
              fileIconColor={"#1a73e8"}
              fileValue={values.file}
              fileOnClick={(e) => {
                e.target.value = ""; //mohm
                setFieldValue("file", e.target.value);
              }}
              FileOnChange={(e) => {
                setFieldValue("file", e.target.files[0]);
              }}
              dropdownId={"hiid"} //mohm
              dataSource={dropdownLists.attachmentTypes}
              dropdownOnChange={(e) => {
                document
                  .querySelector("#hiid")
                  .setAttribute("style", "visibility:visible "); //mohm
                setFieldValue("fileType", e.value);
              }}
              dropdownOnFocus={(e) => {
                document.querySelector("#hiid ~ .e-float-text").textContent =
                  " "; //mohm
              }}
              uploadButtonOnChange={() => {
                if (values.file && values.fileType) {
                  if (
                    !files.find(
                      (item) => item.fileName === values.file.name.substr(0, 35)
                    )
                  ) {
                    const allFiles = [
                      ...files,
                      {
                        id: files.length + 1,
                        fileType: dropdownLists.attachmentTypes.find(
                          (item) => values.fileType === item.id
                        ).id,
                        fileName: values.file.name.substr(0, 35),
                      },
                    ];
                    setFieldValue("attachment", [...allFiles]);
                    setFiles([...allFiles]);
                    setFieldValue("fileType", "");
                    setFieldValue("fileType", "");
                    setFieldValue("file", "");
                    setFieldTouched("attachment", false);
                    setError(false);
                    iconClick();
                  } else {
                    setDuplicateAlert(true);
                    setTimeout(() => {
                      setDuplicateAlert(false);
                    }, 1000);
                  }
                } else {
                  setNoFilesAlert(true);
                  setTimeout(() => {
                    setNoFilesAlert(false);
                  }, 1000);
                }
              }}
            />
            <FilesList
              containerStyle={"col-md-10 col-12 justify-content-center"}
              contentStyle={"col-md-10 col-12"}
              Data={[...files]}
              setFiles={setFiles}
              setFilesInFormik={setFieldValue}
              setFilesTouched={setFieldTouched}
              error={error}
              setError={setError}
              propInFormik={"attachment"}
            />
          </>
        ) : null}
        <div
          className="col-12 justify-content-center d-flex my-3 flex-wrap"
          dir={getDir(getCurrentLangFromRedux())}
        >
          <Button
            content={Lang.prevButton}
            onClick={prevRender}
            containerStyle={"col-lg-3 col-md-3 col-8 mx-3 my-2"}
          />
          <Button
            onClick={() => {
              if (files.length) setError(false);
              else setError(true);
            }}
            type={"submit"}
            content={Lang.nextButton}
            containerStyle={"col-lg-3 col-md-3 col-8 mx-3 my-2"}
          />
        </div>
      </form>
    </>
  );
};

export default PageTwo;

const iconClick = () => {
  document.querySelector("#hiid").setAttribute("style", "visibility:hidden");
  document.querySelector("#hiid ~ .e-float-text").textContent = "نوع الملف";
  document
    .querySelector("#hiid ~ .e-float-text")
    .classList.remove("e-label-top");
  document
    .querySelector("#hiid ~ .e-float-text")
    .classList.add("e-label-bottom");
};
